import BBSearchForm from "./BBSearchForm"
import BBManualEntry from "./BBManualEntry"
import RecentFloorRequests from "./RecentFloorRequests"
import Breadcrumbs from "../../common/Breadcrumbs"
import useStore from "../../../store"
import { useState } from "react"
import useUserType from "../../../hooks/useUserType"

export default function Blackbook() {
  const { isEmployee, isDealer } = useUserType()

  const [formValues, setFormValues] = useState({ vin: '', mileage: '', make: '', model: '', model_year: '', series: '' })
  const [isManualEntry, setIsManualEntry] = useState(false)

  return(
    <div className="flex flex-col grow items-center overflow-y-auto w-full">
      <div className="relative w-full lg:w-1/2 grow overflow-x-hidden">
        {isEmployee && <Breadcrumbs/>}
        {isManualEntry ?
          <BBManualEntry formValues={formValues} setFormValues={setFormValues} setIsManualEntry={setIsManualEntry} /> :
          <BBSearchForm formValues={formValues} setFormValues={setFormValues} setIsManualEntry={setIsManualEntry} />
        }
        {isDealer && <RecentFloorRequests />}
      </div>
    </div>
  )
}